'use strict';
module.exports = function(app) {
    app.service('admin', function () {
        var isAuthenticated = false;
        return {
            isAuthenticated: function () {
                return isAuthenticated;
            },
            setAdminAuthenticated: function () {
                isAuthenticated = true;
            }
        };
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./bidding_product/js/service/admin.service.js
 ** module id = 57
 ** module chunks = 0
 **/